import { supabase } from './supabase'
import { todayISO } from './utils'

export async function fetchDiasLetivosSet(anoInicio: number, anoFim: number): Promise<Set<string>> {
  const { data, error } = await supabase
    .from('calendario')
    .select('data')
    .eq('tipo', 'letivo')
    .gte('data', `${anoInicio}-01-01`)
    .lte('data', `${anoFim}-12-31`)
    .order('data')

  if (error) throw new Error(error.message)

  return new Set((data || []).map((row) => String(row.data).slice(0, 10)))
}

export function isDiaLetivo(iso: string, letivos: Set<string>) {
  return letivos.has(iso.slice(0, 10))
}

/** Primeiro dia letivo em ou após a data informada. */
export function diaLetivoDesde(iso: string, letivos: Set<string>, maxDias = 366): string | null {
  const start = iso.slice(0, 10)
  const d = new Date(`${start}T12:00:00`)
  for (let i = 0; i <= maxDias; i++) {
    const cur = d.toISOString().slice(0, 10)
    if (letivos.has(cur)) return cur
    d.setDate(d.getDate() + 1)
  }
  return null
}

/** Próximo dia letivo estritamente após a data informada. */
export function proximoDiaLetivoApos(iso: string, letivos: Set<string>, maxDias = 366): string | null {
  const d = new Date(`${iso.slice(0, 10)}T12:00:00`)
  for (let i = 0; i < maxDias; i++) {
    d.setDate(d.getDate() + 1)
    const cur = d.toISOString().slice(0, 10)
    if (letivos.has(cur)) return cur
  }
  return null
}

export function defaultsPeriodoLetivo(letivos: Set<string>) {
  const hoje = todayISO()
  const inicio = hoje
  const fim = proximoDiaLetivoApos(hoje, letivos) ?? hoje
  const entrega = diaLetivoDesde(hoje, letivos) ?? hoje
  return { inicio, fim, entrega }
}
